/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Public_DescInputs */

const en_story_public_desc = /** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone can view this story`)
};

const es_story_public_desc = /** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquiera puede ver esta historia`)
};

const fr_story_public_desc = /** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout le monde peut voir cette story`)
};

const de_story_public_desc = /** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder kann diese Story sehen`)
};

const id_story_public_desc = /** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa pun dapat melihat cerita ini`)
};

/** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */
const ja_story_public_desc = en_story_public_desc;

/** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */
const zh_story_public_desc = en_story_public_desc;

/** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */
const ar_story_public_desc = en_story_public_desc;

/** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */
const it_story_public_desc = en_story_public_desc;

/** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */
const ru_story_public_desc = en_story_public_desc;

/** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */
const pt_story_public_desc = en_story_public_desc;

/** @type {(inputs: Story_Public_DescInputs) => LocalizedString} */
const ko_story_public_desc = en_story_public_desc;

/**
* | output |
* | --- |
* | "Anyone can view this story" |
*
* @param {Story_Public_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_public_desc = /** @type {((inputs?: Story_Public_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Public_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_public_desc(inputs)
	if (locale === "es") return es_story_public_desc(inputs)
	if (locale === "fr") return fr_story_public_desc(inputs)
	if (locale === "de") return de_story_public_desc(inputs)
	if (locale === "ja") return ja_story_public_desc(inputs)
	if (locale === "zh") return zh_story_public_desc(inputs)
	if (locale === "ar") return ar_story_public_desc(inputs)
	if (locale === "id") return id_story_public_desc(inputs)
	if (locale === "it") return it_story_public_desc(inputs)
	if (locale === "ru") return ru_story_public_desc(inputs)
	if (locale === "pt") return pt_story_public_desc(inputs)
	return ko_story_public_desc(inputs)
});